import axios from 'axios';
import alertify from 'alertifyjs';

export default {
    data() {
        return {
            deleteActionUrl: null,
            publishActionUrl: null,
            draftActionUrl: null,
            selectedRows: [],
            selectAllCheckbox: false,
            selectOptions: {
                bulkActions: [],
            },
            bulkAction: null
        };
    },
    computed: {
        apiKey: function () {
            return this.$store.getters['root/apiKey'];
        }
    },
    methods: {
        toggleAllCheckboxes: function (checked) {
            this.selectedRows = [];

            if (checked) {
                this.items.forEach((value) => {
                    this.selectedRows.push(value.id);
                })
            }
        },
        callBulkAction(ids, actionType) {
            this.isBusy = true;

            let httpMethod;
            let url;
            let deleteConfig;
            let putConfig;

            switch(actionType) {
                case('delete'): {
                    url = this.deleteActionUrl;
                    httpMethod = 'delete';
                    break;
                }
                case('publish'): {
                    httpMethod = 'put';
                    url = this.publishActionUrl;
                    break;
                }
                case('draft'): {
                    httpMethod = 'put';
                    url = this.draftActionUrl;
                    break;
                }
                case('export'): {
                    httpMethod = 'post';
                    url = this.exportActionUrl;
                    break;
                }
            }

            deleteConfig = {
                headers: {
                    Authorization: 'iii'
                },
                data: { ids: ids }
            };

            putConfig = { ids: ids };

            const config = httpMethod === 'delete' ? deleteConfig : putConfig;

            axios[httpMethod](url, config)
                .then((resp) => {
                    this.loadItems();
                    this.selectedRows = [];
                    this.selectAllCheckbox = false;
                    alertify.success('Action success.');
                    switch(actionType) {
                        case('export'): {
                            let url = window.URL.createObjectURL(new Blob([resp.data]));
                            let pom = document.createElement('a');
                            pom.setAttribute('href', url)
                            pom.setAttribute('download', `export-${new Date().getTime()}.csv`);
                            pom.click(); // this will download the file
                            break;
                        }
                    }
                })
                .catch(errors => {
                    this.loadItems();
                    console.error(errors);
                    alertify.error('Action fail.');
                });
        }
    }
}
